<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong>Sync Grade & Passing Marks</strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="getStd()"
                        persistent-hint hint="Select academic year" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data">
                    <v-btn class="mt-6 button" @click="save()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>

        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import axios from "axios";

import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        overlay: false,
        valid: false,
        errorMsg: {},
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
        search: "",
        snackbar_msg: "",
        color: "",
        snackbar: false,
        ay_std_div_list: null,
        sel_ay_data: null,
    }),
   
    mounted() {
        this.onLoad();
    },
    methods: {
      
        onLoad() {
            this.overlay = true;
            axios
                .post("/commonAPI/get_ay_std_div")
                .then((res) => {
                    this.overlay = false;
                    this.ay_std_div_list = res.data.data;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
      
        save() {
            const data = {
                ay: this.sel_ay_data.ay_id,
            }
            this.overlay =  true
            axios
                .post("/Examination/saveGradePassingMarks",data)
                .then((res) => {
                    this.overlay =  false
                    this.showSnackbar("#4caf50", "saved...");
                })
                .catch((error) => {
                    window.console.log(error);
                    this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on success
                });
            this.close();
        },
    },
};
//};
</script>
<style scoped>

</style>

